import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import msgConstants from '../../../../constants/msgConstants'
import { apiGenerationModalStyles } from './ApiGenerationModal.styles'
import { ModalApiGenerationProps } from './ApiGenerationModal.View'
import { ManualApiPayload } from '../../../../types/ciclosApiType'

export enum TipoGatilhoCiclo {
  MANUAL = 1,
  AUTOMATICO = 2
}

export function modalApiGenerationIO({ isClosed, handleConfirmar }: ModalApiGenerationProps) {
  const schema = yup
    .object({
      startDate: yup.date().nullable().required(msgConstants.USO_GENERICO.campo_obrigatorio),
      endDate: yup
        .date()
        .nullable()
        .required(msgConstants.USO_GENERICO.campo_obrigatorio)
        .min(yup.ref('startDate'), 'A data final deve ser maior ou igual à data inicial'),
      comment: yup.string().required(msgConstants.USO_GENERICO.campo_obrigatorio)
    })
    .required()

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset
  } = useForm<ManualApiPayload>({
    defaultValues: {
      startDate: new Date(),
      endDate: new Date(),
      gatilho: TipoGatilhoCiclo.MANUAL,
      comment: ''
    },
    resolver: yupResolver(schema)
  })

  const fecharModal = () => {
    isClosed()
    reset()
  }

  const submit = (data: ManualApiPayload) => {
    if (data.startDate && data.endDate) {
      const payload: ManualApiPayload = {
        startDate: data.startDate,
        endDate: data.endDate,
        gatilho: data.gatilho,
        comment: data.comment
      }
      handleConfirmar(payload)
    }
  }

  return {
    styles: apiGenerationModalStyles,
    control,
    handleSubmit,
    errors,
    fecharModal,
    submit
  }
}

export type ModalApiGenerationIO = ReturnType<typeof modalApiGenerationIO>
